<template>
  <div>
    <h5 class="modal-title">
      {{ chartTitle }}
      <span class="text-uppercase" style="color: black"> </span>
    </h5>
    <div class="row">
      <div class="chart-section">
        <div>
          <canvas
            :style="{ width: '200px', height: graphHeight }"
            id="myChart"
          ></canvas>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- /* global Chart */ -->
<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
export default {
  name: "MasterGraphCanvas",

  data() {
    return {
      chart: null,
    };
  },

  props: {
    myChartData: {
      type: Object,
      required: true,
    },
    chartTitle: {
      type: String,
      required: true,
    },
    chartType: {
      type: String,
      required: true,
    },
    graphHeight: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },
    renderChart(data) {
      const ctx = document.getElementById("myChart").getContext("2d");
      this.chart = new Chart(ctx, {
        type: this.chartType,
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      });
    },
  },
  mounted() {
    this.renderChart(this.myChartData);
  },
};
</script>

<!-- chartHeight: "400px",
chartTitle: "Graph Title",
chartType: "line",
myChartData: {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "june",
    "july",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      type: "line", // radar, line, bar, polarArea
      label: "Sample Data",
      backgroundColor: "rgba(65, 190, 12, 0.7)",
      borderColor: "rgba(75, 192, 192, 1)",
      data: [65, 59, 80, 81, 56, 65, 59, 80, 81, 56, 77, 80],
      // fill: true, // for area graph
      // tension: 0.2, //for curve
      // pointRadius: 4, // Size of the dots
      // pointBackgroundColor: "rgba(255, 0, 192, 1)", // Color of the dots
      // pointStyle: "circle", // Shape of the dots (circle, triangle, rect, etc.)
    },
  ],
}, -->
